import React, { useContext } from 'react';
import { makeStyles } from '@fluentui/react-components';
import { MessageBar, MessageBarBody } from '@fluentui/react-message-bar';
import { I18nContext } from '@bingads-webui-react/i18n-context';

import { dateSettingsManageAtAdGroupLevelText } from './constants';

const useStyles = makeStyles({
  messageBar: {
    marginTop: '10px',
  },
});

export const DateManagementInfo = () => {
  const i18n = useContext(I18nContext);
  const classes = useStyles();

  return (
    <>
      <div className={classes.messageBar}>
        <MessageBar intent="info">
          <MessageBarBody>
            {i18n.getString(dateSettingsManageAtAdGroupLevelText)}
          </MessageBarBody>
        </MessageBar>
      </div>
    </>
  );
};
